export const Layout = (props: any) => (
    <div id="content">
        {props.children}
    </div>

)